var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.allSupportingNetwork
        ? _c(
            "div",
            {
              staticStyle: {
                position: "absolute",
                "z-index": "999",
                top: "200px",
                right: "50px",
              },
            },
            [
              _c("factor-base-reveal-network", {
                key: 999,
                ref: "mechanismNetwork-" + 999,
                attrs: {
                  network: _vm.allSupportingNetwork,
                  genes: [],
                  width: 640,
                  height: 360,
                  "show-popup-button": true,
                },
                on: {
                  "open-popup": function ($event) {
                    return _vm.helpers.openNetworkPopup({
                      index: 999,
                      hypothesisMap: false,
                    })
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.networkPopupMechanismIndex !== null &&
      _vm.mechanisms &&
      _vm.mechanisms[_vm.networkPopupMechanismIndex] &&
      (_vm.networkPopupIsHypothesisMap
        ? _vm.mechanisms[_vm.networkPopupMechanismIndex].core_spine_network &&
          _vm.mechanisms[_vm.networkPopupMechanismIndex].core_spine_network
            .nodes &&
          _vm.mechanisms[_vm.networkPopupMechanismIndex].core_spine_network
            .nodes.length
        : (_vm.mechanisms[_vm.networkPopupMechanismIndex].supporting_network &&
            _vm.mechanisms[_vm.networkPopupMechanismIndex].supporting_network
              .nodes &&
            _vm.mechanisms[_vm.networkPopupMechanismIndex].supporting_network
              .nodes.length) ||
          (_vm.mechanisms[_vm.networkPopupMechanismIndex].network &&
            _vm.mechanisms[_vm.networkPopupMechanismIndex].network.nodes &&
            _vm.mechanisms[_vm.networkPopupMechanismIndex].network.nodes
              .length))
        ? _c(
            "div",
            {
              staticClass: "network-popup-overlay",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.helpers.closeNetworkPopup.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "network-popup-box" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "network-popup-header d-flex justify-content-between align-items-center",
                  },
                  [
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v(
                        _vm._s(
                          _vm.networkPopupIsHypothesisMap
                            ? "Hypothesis map (biological mechanism)"
                            : "Supporting network"
                        )
                      ),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-secondary",
                        attrs: { type: "button", "aria-label": "Close" },
                        on: { click: _vm.helpers.closeNetworkPopup },
                      },
                      [_c("b-icon", { attrs: { icon: "x" } })],
                      1
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "network-popup-body" },
                  [
                    _c("factor-base-reveal-network", {
                      key:
                        "popup-" +
                        _vm.networkPopupMechanismIndex +
                        "-" +
                        (_vm.networkPopupIsHypothesisMap
                          ? "hypothesis"
                          : "supporting"),
                      attrs: {
                        network: _vm.networkPopupIsHypothesisMap
                          ? _vm.mechanisms[_vm.networkPopupMechanismIndex]
                              .core_spine_network
                          : _vm.mechanisms[_vm.networkPopupMechanismIndex]
                              .supporting_network ||
                            _vm.mechanisms[_vm.networkPopupMechanismIndex]
                              .network,
                        genes:
                          _vm.mechanisms[_vm.networkPopupMechanismIndex]
                            .candidate_genes ||
                          _vm.mechanisms[_vm.networkPopupMechanismIndex]
                            .genes ||
                          [],
                        width: _vm.popupNetworkWidth,
                        height: _vm.popupNetworkHeight,
                        "show-popup-button": false,
                        "is-mechanism-flow-map":
                          _vm.networkPopupIsHypothesisMap,
                        "keep-physics-enabled":
                          !_vm.networkPopupIsHypothesisMap,
                        "use-gene-role-colors": _vm.networkPopupIsHypothesisMap,
                        "highlight-anchor-genes":
                          !_vm.networkPopupIsHypothesisMap,
                        "is-biolink-map":
                          _vm.networkPopupIsHypothesisMap &&
                          _vm.helpers.isMechanismUsingBiolinkMap(
                            _vm.mechanisms[_vm.networkPopupMechanismIndex]
                          ),
                        "show-hypothesis-map-view-toggle":
                          _vm.networkPopupIsHypothesisMap &&
                          _vm.helpers.hasMechanismBiolinkNetwork(
                            _vm.mechanisms[_vm.networkPopupMechanismIndex]
                          ),
                        "show-original-hypothesis-map":
                          _vm.networkPopupIsHypothesisMap &&
                          !_vm.helpers.isMechanismUsingBiolinkMap(
                            _vm.mechanisms[_vm.networkPopupMechanismIndex]
                          ),
                      },
                      on: {
                        "hypothesis-original-map": function ($event) {
                          return _vm.helpers.setMechanismMapViewMode(
                            _vm.networkPopupMechanismIndex,
                            $event ? "original" : "biolink"
                          )
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: {
            visible: _vm.factorConnectivityPopupOpen,
            size: "xl",
            title: "Phenotype-gene set-gene connectivity",
            "hide-footer": "",
            "body-class": "pt-2 pb-2",
          },
          on: {
            change: function ($event) {
              return _vm.$emit("update:factorConnectivityPopupOpen", $event)
            },
          },
        },
        [
          _vm.factorConnectivityPopupRow
            ? _c("div", { staticClass: "small text-muted mb-2" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.helpers.getPhenotypeDisplay(
                        _vm.factorConnectivityPopupRow.phenotype
                      )
                    ) +
                    " - " +
                    _vm._s(
                      _vm.helpers.getFactorClusterDisplay(
                        _vm.factorConnectivityPopupRow
                      )
                    ) +
                    " "
                ),
              ])
            : _vm._e(),
          _vm.factorConnectivityPopupNetwork &&
          _vm.factorConnectivityPopupNetwork.nodes &&
          _vm.factorConnectivityPopupNetwork.nodes.length
            ? _c("factor-base-reveal-network", {
                attrs: {
                  network: _vm.factorConnectivityPopupNetwork,
                  width: _vm.popupNetworkWidth,
                  height: _vm.popupNetworkHeight,
                  "show-popup-button": false,
                  "keep-physics-enabled": "",
                  "gene-node-metric-key": "gwas_support",
                  "gene-color-by-gwas-support": "",
                  "edge-distance-metric-key": "functional_support",
                },
              })
            : _c("div", { staticClass: "small text-muted" }, [
                _vm._v("No connectivity graph data available for this row."),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }